import React from 'react';
import { DefaultIconProps } from './types';

const SquaredCopy: React.FC<DefaultIconProps> = ({
  className, color = '#151515', width, height,
}) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 16">
    <path d="M0 0h16v16H0z" style={{ fill: 'none', fillRule: 'evenodd' }} />
    <path d="M5.333 5.333V2.667A.667.667 0 0 1 6 2h8.667a.667.667 0 0 1 .667.667v8.667a.667.667 0 0 1-.667.667H12v2.662a.671.671 0 0 1-.671.671H2.671A.671.671 0 0 1 2 14.662V6a.671.671 0 0 1 .671-.671zm1.333 0h4.662A.671.671 0 0 1 12 6v4.662h2V3.333H6.667zM3.335 6.667V14h7.333V6.667z" transform="translate(-.667 -.667)" style={{ fill: color }} />
  </svg>

);

export default SquaredCopy;
